module.exports = __webpack_public_path__ + "img/mt5-icon6.660b40f.png";